import { passwordChangeAction } from 'reg_redesign/actions';
import { passwordMapDispatchToProps } from 'reg_redesign/redux/connectFunctions';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import disabledStyle from 'fields/rebrand/styles/DisabledStyle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import Password from 'components/component_lib/Password';

export default {
  defaultNextPage: 'page-15',
  content: [
    configureProgressBar(89),
    configureTitle('Set credentials for your account.'),
    {
      component: BasicInput,
      props: {
        id: 'email',
        label: 'Email',
        type: 'text',
        formControlStyle: {
          marginBottom: '1.5rem'
        },
        isDisabled: true,
        disabledStyle
      }
    },
    {
      component: Password,
      name: 'password',
      dispatchOverride: passwordMapDispatchToProps,
      props: {
        id: 'password',
        label: 'Password',
        onMount: passwordChangeAction,
        onChange: passwordChangeAction
      }
    },
    nextButtonConfig('page-14')
  ]
};
